import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allLSMRejectionReason: [],
    LSMRejectReasonDropDown:[],
    addModal: false
};


// fetch the all lsm_rejection_reason list 
export const fetchAllLSMRejectionReason = createAsyncThunk(
    'bmr/fetchAllLSMRejectionReason',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/lsm_rejection_reasons');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add lsm_rejection_reason
export const addLSMRejectionReason = createAsyncThunk(
    'bmr/addLSMRejectionReason',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/lsm_rejection_reasons/create', args);
            notify.success(response.data.message);
            dispatch(disableAddModal())
            dispatch(fetchAllLSMRejectionReason());
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit lsm_rejection_reason
export const editLSMRejectionReason = createAsyncThunk(
    'bmr/editLSMRejectionReason',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId } = args;
            const response = await api.put(`/lsm_rejection_reasons/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal())
            dispatch(fetchAllLSMRejectionReason());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// delete lsm_rejection_reason
export const deleteLSMRejectionReason = createAsyncThunk(
    'bmr/deleteLSMRejectionReason',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id } = args;
            const response = await api.delete(`/lsm_rejection_reasons/${id}`);
            notify.success(response.data.message);
            dispatch(fetchAllLSMRejectionReason());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// @info get Esential patient for the portal 1
export const fetchLSMRejectionReasonDropDown = createAsyncThunk(
    'bmr/fetchLSMRejectionReasonDropDown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/lsm_rejection_reasons/active/status`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const bmrLsmRejectionReasonSlice = createSlice({
    name: 'bmrLsmRejectionReason',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all primary diagnosis list
        builder
            .addCase(fetchAllLSMRejectionReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllLSMRejectionReason.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLSMRejectionReason = action.payload.data
            })
            .addCase(fetchAllLSMRejectionReason.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle add location
        builder
            .addCase(addLSMRejectionReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addLSMRejectionReason.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addLSMRejectionReason.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle edit location
        builder
            .addCase(editLSMRejectionReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editLSMRejectionReason.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editLSMRejectionReason.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle delete location
        builder
            .addCase(deleteLSMRejectionReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteLSMRejectionReason.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteLSMRejectionReason.rejected, (state) => {
                state.isLoading = false;
            })
            // dropdown
            .addCase(fetchLSMRejectionReasonDropDown.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchLSMRejectionReasonDropDown.fulfilled, (state, action) => {
                state.isLoading = false;
                state.LSMRejectReasonDropDown = action.payload.data.items?.map(op => { return { value: op?.id, label: op.name } })
            })
            .addCase(fetchLSMRejectionReasonDropDown.rejected, (state) => {
                state.isLoading = false;
            });
    },
});
export const { disableAddModal, enableAddModal } = bmrLsmRejectionReasonSlice.actions

export const selectLSMRejectionReasonLoading = (state) => state.bmrLsmRejectionReason.isLoading;
export const selectLSMRejectionReasonAll = (state) => state.bmrLsmRejectionReason.allLSMRejectionReason;
export const selectBmrAddLSMREjectionReasonModal = (state) => state.bmrLsmRejectionReason.addModal
export const selectBmrLsmRejectionReasonDropdown = (state) => state.bmrLsmRejectionReason.LSMRejectReasonDropDown;









export default bmrLsmRejectionReasonSlice.reducer;
